<template>
  <div>
    <!-- 顶部导航 -->
    <div class="header-wrapper">
      <div class="header container">
        <div class="logo">
          <span class="logo-icon">青蓝</span>
          <span class="tag-line">青蓝校园</span>
        </div>
        <nav class="main-nav">
          <ul>
            <li><router-link to="/" exact>首页</router-link></li>
            <li><router-link to="/help">问答</router-link></li>
            <li><router-link to="/activity">活动</router-link></li>
            <li><router-link to="/job">招聘信息</router-link></li>
            <li><router-link to="/oldstuff">二手信息</router-link></li>
            <li><router-link to="/news">文章/新闻</router-link></li>
            <li class="user-area">
              <template v-if="!userinfo">
                <span class="login-link" @click="closein">登录/注册</span>
              </template>
              <template v-else>
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link nickname-link">
                    <el-badge :value="unread" :hidden="unread === 0" style="margin-right: 6px;">
                      <img :src="userinfo.avatar || $img.portrait" style="width: 30px; height: 30px; border-radius: 50%; vertical-align: middle;" />
                    </el-badge>
                    {{ userinfo.nickname }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="admin">个人中心</el-dropdown-item>
                    <el-dropdown-item command="notice">
                      <el-badge :value="unread" :hidden="unread === 0">消息中心</el-badge>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- 搜索区 -->
    <div class="search-area-wrapper">
      <div class="container">
        <h3 class="search-header">让校园信息自由流动</h3>
        <p class="search-tag-line">Qinglan Campus · Find, share and connect on campus</p>
        <div class="search-form">
          <input class="search-term" v-model="search" placeholder="搜索问答、二手、活动、岗位、文章……" @keyup.enter="dosearch" />
          <input class="search-btn" type="button" value="搜索" @click="dosearch" />
        </div>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="page-container">
      <div class="container">
        <router-view />
      </div>
    </div>

    <!-- footer -->
    <foot />

    <!-- 登录/注册弹窗 -->
    <div v-if="isclose">
      <div id="mask" @click="close"></div>
      <div id="loginBox">
        <span class="close" @click="close">✕</span>
        <p class="title">{{ islogin ? '网站登录' : '新用户注册' }}</p>
        <el-form :model="loginForm" label-width="60px">
          <el-form-item label="账号">
            <el-input v-model="loginForm.username" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" @keyup.enter.native="submit"></el-input>
          </el-form-item>
          <el-form-item v-if="!islogin" label="确认">
            <el-input v-model="loginForm.password1" type="password" placeholder="请再次输入密码" @keyup.enter.native="submit"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%;" @click="submit">{{ islogin ? '登 录' : '注 册' }}</el-button>
          </el-form-item>
        </el-form>
        <p class="switch-line">
          <a @click="join">{{ islogin ? '注册新用户' : '快去登录' }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import foot from '@/components/foot.vue'
import { login, registered, getNotice } from '@/api'

export default {
  name: 'Index',
  components: { foot },
  data() {
    return {
      search: '',
      loginForm: { username: '', password: '', password1: '' }
    }
  },
  computed: {
    ...mapState({
      isclose: (s) => s.user.isclose,
      islogin: (s) => s.user.islogin,
      userinfo: (s) => s.user.userinfo,
      unread: (s) => s.user.unread
    })
  },
  created() {
    if (localStorage.luffy_jwt_token) {
      getNotice({ num: 1 }).then((res) => {
        this.$store.dispatch('user/setunread', (res.data && res.data.count) || 0)
      }).catch(() => {})
    }
  },
  methods: {
    closein() {
      this.$store.dispatch('user/changeislogin', true)
      this.$store.dispatch('user/close', true)
    },
    close() {
      this.$store.dispatch('user/close', false)
    },
    join() {
      this.$store.dispatch('user/changeislogin', !this.islogin)
    },
    submit() {
      if (!this.loginForm.username || !this.loginForm.password) {
        this.$message.error('账号或密码不能为空')
        return
      }
      if (!this.islogin) {
        if (this.loginForm.password !== this.loginForm.password1) {
          this.$message.error('两次密码不相等')
          return
        }
        if (!/^[1-9a-zA-Z][0-9a-zA-Z]{5,9}$/.test(this.loginForm.username)) {
          this.$message.error('账号须为 6-10 位字母或数字，且不以 0 开头')
          return
        }
        if (!/^[a-zA-Z]\w{5,17}$/.test(this.loginForm.password)) {
          this.$message.error('密码须为 6-18 位，字母开头，可含字母数字下划线')
          return
        }
        registered({ username: this.loginForm.username, password: this.loginForm.password }).then((res) => {
          if (res.state.type === 'ERROR_PARAMS_EXIST') {
            this.$message.error('用户名已存在')
            return
          }
          this.$message.success('注册成功，请登录')
          this.$store.dispatch('user/changeislogin', true)
        })
        return
      }
      login({ username: this.loginForm.username, password: this.loginForm.password, type: '' }).then((res) => {
        if (res.state && res.state.type === 's') {
          const act = res.data && res.data.activationdate
          this.$message.error('账号因不良行为被限制登录' + (act ? '，解封时间：' + new Date(Number(act)).toLocaleString() : ''))
          return
        }
        if (res.state.type !== 'SUCCESS') {
          this.$message.error('用户名或密码错误')
          return
        }
        this.$store.dispatch('user/setUserInfo', res.data.userinfo)
        localStorage.setItem('luffy_jwt_token', res.data.token)
        this.close()
        this.$message.success('登录成功')
        getNotice({ num: 1 }).then((r) => {
          this.$store.dispatch('user/setunread', (r.data && r.data.count) || 0)
        }).catch(() => {})
      })
    },
    dosearch() {
      if (!this.search.trim()) {
        this.$message.error('关键字不能为空')
        return
      }
      this.$router.push({ path: '/search', query: { search: this.search.trim() } })
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$store.dispatch('user/deleteuserinfo')
        this.$message.success('退出成功')
        if (this.$route.path.indexOf('/admin') === 0) this.$router.push('/home')
      } else if (command === 'admin') {
        this.$router.push('/admin')
      } else if (command === 'notice') {
        this.$router.push('/admin/notice')
      }
    }
  }
}
</script>
